import { AppBar, Button, Dialog, Grid, List, ListItem, ListItemText, Toolbar, Typography } from "@mui/material"
import { useListaCEPService } from "../../../../../../../../../use-cases/geo-veles"
import { useAppSelector } from "../../../../../../../../hooks/store-hooks"
import { Transition } from "../../../../../../../../components"
import { FileUpload } from "./FileUpload"
import { useState } from "react"
import { ListItemButtonStyled } from "./ListItemButtonStyled"
import { ColumnsDialog } from "../../columns-dialog"
import { PreviewListaCEP } from "./PreviewListaCEP"
import '../../../../../../../../assets/css/fileUploadStyle.css'

export const ListaCEPImportFile = (props: {
    openImportFile: boolean
}) => {
    // State
    const { listaCEP } = useAppSelector((state) => state)
    // Use State
    const [columnDialogOpen, setColumnDialogOpen] = useState<boolean>(false)
    // Hook
    const {
        openImportFileListaCEP,
        verifyListaCEPFileData,
        openPreviewListaCEP,
        selectColumn
    } = useListaCEPService()

    return (
        <>
            <Dialog
                fullWidth
                maxWidth="xl"
                open={listaCEP.openImportFileListaCEP}
                TransitionComponent={Transition}
                onClose={() => {
                    openImportFileListaCEP(false)
                }}
            >
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <Typography sx={{ ml: 2, flex: 1 }} textTransform="uppercase" variant="h6" component="div">
                            Importar arquivo de lista de CEPs
                        </Typography>
                        <Button
                            autoFocus
                            color="inherit"
                            onClick={() => {
                                openImportFileListaCEP(false)
                            }}
                        >
                            Fechar
                        </Button>
                    </Toolbar>
                </AppBar>
                <form onSubmit={(e) => {
                    e.preventDefault()
                    openImportFileListaCEP(false)
                }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            {/* Drag and drop component*/}
                            <FileUpload label={"Arraste e solte o arquivo aqui ou clique para selecionar"} />
                        </Grid>
                        {
                            listaCEP.matchCode.selectedColumn !== '' ? (
                                <>
                                    <Grid item xs={6}>
                                        <List component="div" role="group">
                                            <ListItem
                                                key={1}
                                                divider
                                                aria-haspopup="true"
                                                aria-controls="ringtone-menu"
                                                aria-label="phone ringtone"
                                                onClick={(() => {
                                                    setColumnDialogOpen(true)
                                                })}
                                            >
                                                <ListItemText key={1}
                                                    primary="Clique para selecionar a coluna"
                                                    secondary={listaCEP.matchCode.selectedColumn}
                                                />
                                            </ListItem>
                                        </List>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <List component="div" role="group">
                                            <ListItemButtonStyled
                                                divider
                                                key={1}
                                            >
                                                <ListItemText primary="Dados do arquivo"
                                                    secondary={
                                                        <>
                                                            <Typography >
                                                                <strong> Nome: </strong>
                                                                {listaCEP.fileData.name}
                                                            </Typography>
                                                            <Typography >
                                                                <strong> Tamanho: </strong>
                                                                {listaCEP.fileData.size}
                                                            </Typography>
                                                            <Typography >
                                                                <strong> Tipo: </strong>
                                                                {listaCEP.fileData.type}
                                                            </Typography>
                                                            <Typography >
                                                                <strong> Linhas: </strong>
                                                                {listaCEP.fileData.data.length.toLocaleString('pt-BR')}
                                                            </Typography>
                                                            <Typography >
                                                                <strong> Match codes distintos: </strong>
                                                                {listaCEP.matchCode.distinctValues.toLocaleString('pt-BR')}
                                                            </Typography>
                                                            <Typography >
                                                                <strong> Match codes válidos e distintos: </strong>
                                                                {listaCEP.matchCode.validValues.toLocaleString('pt-BR')}
                                                            </Typography>
                                                        </>
                                                    }
                                                />
                                            </ListItemButtonStyled>
                                        </List>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                            onClick={() => {
                                                if (verifyListaCEPFileData()) {
                                                    openPreviewListaCEP(true)
                                                }
                                            }}
                                        >
                                            Enviar
                                        </Button>
                                    </Grid>
                                </>
                            ) : null
                        }
                    </Grid>
                    <ColumnsDialog
                        id="ringtone-menu"
                        keepMounted
                        open={columnDialogOpen}
                        onClose={(newValue?: string) => {
                            if (newValue) {
                                selectColumn({
                                    selectedColumn: newValue
                                })
                            }
                            setColumnDialogOpen(false)
                        }}
                        value={listaCEP.matchCode.selectedColumn}
                    />
                </form>
            </Dialog>

            <PreviewListaCEP openPreviewListaCEP={listaCEP.openPreviewListaCEP} />
        </>
    )
}